import { render } from "./TeamEvents.vue?vue&type=template&id=27bd90c5"
import script from "./TeamEvents.vue?vue&type=script&lang=js"
export * from "./TeamEvents.vue?vue&type=script&lang=js"

import "./TeamEvents.vue?vue&type=style&index=0&id=27bd90c5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__